import { z } from 'zod';
/**
 * Skill `document-generation` (Paket I, Issue #95).
 *
 * Erzeugt PDF/DOCX/JSON-Dokumente aus dem aktuellen Project-State oder einem
 * ProjectVersion-Snapshot. Das Layout (Briefkopf, Sektionen, Unterschrift)
 * lebt server-seitig in den Templates — der Client bestimmt nur Format und
 * optional Quelle (aktueller Stand vs. Version-Snapshot).
 */
export const generateDocumentRequest = z
    .object({
    kind: z.enum(['pdf', 'docx', 'json']),
    template: z.enum(['brandschutznachweis', 'brandschutzkonzept']).optional(),
    /** Optional: aus einer Version snapshotten statt aktueller Project-State. */
    versionNo: z.number().int().positive().optional(),
})
    .strict();
